// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/zipcode.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/zipcode.proto.
 */
export const file_api_proto_v1_zipcode: GenFile = /*@__PURE__*/
  fileDesc("ChphcGlfcHJvdG8vdjEvemlwY29kZS5wcm90bxIMYXBpX3Byb3RvLnYxIiUKEUdldEFkZHJlc3NSZXF1ZXN0EhAKCHppcF9jb2RlGAEgASgJIiQKEUdldFppcENvZGVSZXF1ZXN0Eg8KB2FkZHJlc3MYASABKAkiXgoSR2V0QWRkcmVzc1Jlc3BvbnNlEhAKCHppcF9jb2RlGAEgASgJEhIKCnByZWZlY3R1cmUYAiABKAkSEAoIYWRkcmVzczEYAyABKAkSEAoIYWRkcmVzczIYBCABKAlCM1oxZ2l0aHViLmNvbS9oLXNjYXBlL2llc2FwdXJpL2dvL2FwaV9wcm90by92MTthcGl2MWIGcHJvdG8z");

/**
 * @generated from message api_proto.v1.GetAddressRequest
 */
export type GetAddressRequest = Message<"api_proto.v1.GetAddressRequest"> & {
  /**
   * @generated from field: string zip_code = 1;
   */
  zipCode: string;
};

/**
 * Describes the message api_proto.v1.GetAddressRequest.
 * Use `create(GetAddressRequestSchema)` to create a new message.
 */
export const GetAddressRequestSchema: GenMessage<GetAddressRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_zipcode, 0);

/**
 * @generated from message api_proto.v1.GetZipCodeRequest
 */
export type GetZipCodeRequest = Message<"api_proto.v1.GetZipCodeRequest"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message api_proto.v1.GetZipCodeRequest.
 * Use `create(GetZipCodeRequestSchema)` to create a new message.
 */
export const GetZipCodeRequestSchema: GenMessage<GetZipCodeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_zipcode, 1);

/**
 * @generated from message api_proto.v1.GetAddressResponse
 */
export type GetAddressResponse = Message<"api_proto.v1.GetAddressResponse"> & {
  /**
   * @generated from field: string zip_code = 1;
   */
  zipCode: string;

  /**
   * @generated from field: string prefecture = 2;
   */
  prefecture: string;

  /**
   * @generated from field: string address1 = 3;
   */
  address1: string;

  /**
   * @generated from field: string address2 = 4;
   */
  address2: string;
};

/**
 * Describes the message api_proto.v1.GetAddressResponse.
 * Use `create(GetAddressResponseSchema)` to create a new message.
 */
export const GetAddressResponseSchema: GenMessage<GetAddressResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_zipcode, 2);

